import markerIconGrayV2 from '@assets/images/icons/icon_marker_gray.png'
import markerIconGreenV2 from '@assets/images/icons/icon_marker_green.png'
import markerIconYellowV2 from '@assets/images/icons/icon_marker_yellow.png'
import FibretraceLabelMarkup from '@components/module-components/POSMap/helper/FibretraceLabelMarkup'
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {translate} from '@src/helpers'
import {E_ProcessClaimedStatus} from '@src/types'
import React, {Fragment, FunctionComponent, ReactNode} from 'react'
import {useSelector} from 'react-redux'
import './VerificationLegend.scss'

const ProcessStatusMap = {
  [E_ProcessClaimedStatus.UNCLAIMED]: {
    imgSource: markerIconYellowV2,
    imgAlt: 'Unclaimed'
  },
  [E_ProcessClaimedStatus.SELF_REPORTED]: {
    imgSource: markerIconYellowV2,
    imgAlt: 'Unclaimed'
  },
  [E_ProcessClaimedStatus.CLAIMED]: {
    imgSource: markerIconGrayV2,
    imgAlt: 'Claimed'
  },
  [E_ProcessClaimedStatus.VERIFIED]: {
    imgSource: markerIconGreenV2,
    imgAlt: 'Verified'
  },
  [E_ProcessClaimedStatus.DISPUTED]: {
    imgSource: markerIconGreenV2,
    imgAlt: 'Disputed'
  }
}

const checkIcon = ({fill = '#519061'}: {fill?: string} = {}) => {
  return (
    <span className={'mr-1'}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        style={{clipPath: 'url(#clip0_2_654)'}}
      >
        <g>
          <path
            d="M11.0597 5.0535L6.66634 9.44683L4.27301 7.06016L3.33301 8.00016L6.66634 11.3335L11.9997 6.00016L11.0597 5.0535ZM7.99967 1.3335C4.31967 1.3335 1.33301 4.32016 1.33301 8.00016C1.33301 11.6802 4.31967 14.6668 7.99967 14.6668C11.6797 14.6668 14.6663 11.6802 14.6663 8.00016C14.6663 4.32016 11.6797 1.3335 7.99967 1.3335ZM7.99967 13.3335C5.05301 13.3335 2.66634 10.9468 2.66634 8.00016C2.66634 5.0535 5.05301 2.66683 7.99967 2.66683C10.9463 2.66683 13.333 5.0535 13.333 8.00016C13.333 10.9468 10.9463 13.3335 7.99967 13.3335Z"
            fill={fill}
          />
        </g>

        <defs>
          <clipPath id="clip0_2_654">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  )
}

const exclaimationIcon = ({fill = '#857446'}: {fill?: string} = {}) => {
  return (
    <span className={'mr-1'}>
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.10033 8.10668H7.26351V9.26986H6.10033V8.10668ZM6.10033 3.45397H7.26351V6.9435H6.10033V3.45397ZM6.6761 0.546021C3.46573 0.546021 0.866028 3.15154 0.866028 6.36191C0.866028 9.57228 3.46573 12.1778 6.6761 12.1778C9.89229 12.1778 12.4978 9.57228 12.4978 6.36191C12.4978 3.15154 9.89229 0.546021 6.6761 0.546021ZM6.68192 11.0146C4.11129 11.0146 2.02921 8.93253 2.02921 6.36191C2.02921 3.79129 4.11129 1.7092 6.68192 1.7092C9.25254 1.7092 11.3346 3.79129 11.3346 6.36191C11.3346 8.93253 9.25254 11.0146 6.68192 11.0146Z"
          fill="#857446"
        />
      </svg>
    </span>
  )
}

type StatusType = {
  badgeClassName: string
  icon: ReactNode
  label: string
  description: string
}

export const getFibreStatus = (status: E_ProcessClaimedStatus): StatusType => {
  let badgeClassName = 'fib-claimed-badge'
  let icon = checkIcon()
  let label = ''
  let description = ''
  switch (status) {
    case E_ProcessClaimedStatus.DISPUTED:
      badgeClassName = 'fib-verification-legend-disputed'
      icon = <FontAwesomeIcon icon={faInfoCircle} className={`mr-1`} />
      // label = "LABEL.B2C.VERIFICATION_LEGEND.STATUS.DISPUTED"
      label = 'Audit Disputed'
      description = 'LABEL.B2C.VERIFICATION_LEGEND.STATUS.DISPUTED.DESCRIPTION'
      break

    case E_ProcessClaimedStatus.SELF_REPORTED:
      badgeClassName = 'fib-verification-legend-selfreport'
      icon = exclaimationIcon()
      // label = "LABEL.B2C.VERIFICATION_LEGEND.STATUS.SELF_REPORTED"
      label = 'Self-Reported'
      description = 'LABEL.B2C.VERIFICATION_LEGEND.STATUS.SELF_REPORTED.DESCRIPTION'
      break

    case E_ProcessClaimedStatus.VERIFIED:
      badgeClassName = 'fib-verification-legend-verified'
      icon = checkIcon()
      // label = "LABEL.B2C.VERIFICATION_LEGEND.STATUS.VERIFIED"
      label = 'Verified'
      description = 'LABEL.B2C.VERIFICATION_LEGEND.STATUS.VERIFIED.DESCRIPTION'
      break

    case E_ProcessClaimedStatus.CLAIMED:
      badgeClassName = 'fib-verification-legend-claimed'
      icon = checkIcon({fill: '#787878'})
      // label = "LABEL.B2C.VERIFICATION_LEGEND.STATUS.CLAIMED"
      label = 'Claimed'
      description = 'LABEL.B2C.VERIFICATION_LEGEND.STATUS.CLAIMED.DESCRIPTION'
      break
  }
  return {badgeClassName, icon, label, description}
}

interface VerificationLegendItemProps {
  status: E_ProcessClaimedStatus
}

const VerificationLegendBadge: FunctionComponent<VerificationLegendItemProps> = ({poz, className = '', status}) => {
  const langData = useSelector((state: any) => state.currentLanguage) as any
  const statusDetails = getFibreStatus(status)

  return (
    <Fragment>
      <div
        className={poz?.fibretrace_id_label ? 'ml-3' : 'ml-3'}
        style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}
      >
        <span className={className + ' ' + statusDetails.badgeClassName}>
          {statusDetails.icon}&nbsp;
          {translate(langData.localize, statusDetails.label)}
        </span>

        <FibretraceLabelMarkup poz={poz} style={{fontSize: '11px', marginTop: '3px', color: '#797A7C'}} />
      </div>
    </Fragment>
  )
}

export default VerificationLegendBadge
